import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { SubAccountType } from '../../Constants/Enums/Domain/SubAccountType';

declare var IS_RUNNING_IN_APP_POOL;

export class WhatIfToolCopyClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public put(hierarchyId: string, subaccountHierarchyId: string, type: SubAccountType): Promise<string, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/WhatIfToolCopy/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, subaccountHierarchyId: subaccountHierarchyId, type: type }

    return AjaxWrapper.put<string, any>(url, data);
  }
}

